import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <div style={styles.logo}>
          <span style={styles.logoText}>NAHHAS</span>
          <span style={styles.logoSubtext}>LUXURY CONSULTING</span>
        </div>

        {/* Desktop Navigation */}
        {!isMobile && (
          <nav style={styles.desktopNav}>
            <button onClick={() => scrollToSection('home')} style={styles.navLink}>Accueil</button>
            <button onClick={() => scrollToSection('about')} style={styles.navLink}>À Propos</button>
            <button onClick={() => scrollToSection('services')} style={styles.navLink}>Services</button>
            <button onClick={() => scrollToSection('contact')} style={styles.navLink}>Contact</button>
          </nav>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <button 
            style={styles.mobileMenuBtn}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        )}
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && isMobile && (
        <nav style={styles.mobileNav}>
          <button onClick={() => scrollToSection('home')} style={styles.mobileNavLink}>Accueil</button>
          <button onClick={() => scrollToSection('about')} style={styles.mobileNavLink}>À Propos</button>
          <button onClick={() => scrollToSection('services')} style={styles.mobileNavLink}>Services</button>
          <button onClick={() => scrollToSection('contact')} style={styles.mobileNavLink}>Contact</button>
        </nav>
      )}
    </header>
  );
};

const styles = {
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    background: 'rgba(0, 0, 0, 0.95)',
    borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
    zIndex: 1000,
    backdropFilter: 'blur(10px)',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '20px 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  logoText: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#D4AF37',
    letterSpacing: '2px',
  },
  logoSubtext: {
    fontSize: '10px',
    fontWeight: '400',
    color: '#FFFFFF',
    letterSpacing: '3px',
  },
  desktopNav: {
    display: 'flex',
    gap: '40px',
    alignItems: 'center',
  },
  navLink: {
    background: 'none',
    border: 'none',
    color: '#8A8A8A',
    fontSize: '16px',
    fontWeight: '400',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    padding: '8px 0',
  },
  mobileMenuBtn: {
    background: 'none',
    border: 'none',
    color: '#D4AF37',
    cursor: 'pointer',
    padding: '8px',
  },
  mobileNav: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 40px',
    gap: '20px',
    background: 'rgba(0, 0, 0, 0.98)',
    borderTop: '1px solid rgba(212, 175, 55, 0.2)',
  },
  mobileNavLink: {
    background: 'none',
    border: 'none',
    color: '#8A8A8A',
    fontSize: '18px',
    fontWeight: '400',
    cursor: 'pointer',
    textAlign: 'left',
    padding: '10px 0',
  },
};

// Add media query styles
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @media (max-width: 768px) {
    .header-container {
      padding: 16px 20px !important;
    }
    .logo-text {
      font-size: 20px !important;
    }
    .logo-subtext {
      font-size: 8px !important;
    }
  }
`;
document.head.appendChild(styleSheet);